import { TableViewModel } from './table';

export abstract class RowViewModel<
  TData extends object,
  TTableViewModel extends TableViewModel<TData, RowViewModel<TData, TTableViewModel>>
> {
  abstract onRowDoubleClick(): void;
  constructor(
    public entity: TData,
    public table: TTableViewModel
  ) {}
}
